import { STATUS_KEY } from './constants';

export const STATUS_DATA = {
  [STATUS_KEY.request]: {
    id: STATUS_KEY.request,
    name: 'На рассмотрении',
    attrs: {
      color: 'ui-warning',
      get textColor() {
        return `${this.color}--text text--darken-1`;
      },
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
    },
  },
  [STATUS_KEY.confirm]: {
    id: STATUS_KEY.confirm,
    name: 'Участник',
    attrs: {
      color: 'ui-success',
      get textColor() {
        return `${this.color}--text`;
      },
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
    },
  },
  [STATUS_KEY.reject]: {
    id: STATUS_KEY.reject,
    name: 'Отклонен',
    attrs: {
      color: 'ui-error',
      get textColor() {
        return `${this.color}--text`;
      },
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
    },
  },
};

export default {
  STATUS_DATA,
};
